import './NoLiveSessions.scss';
import images from '../../assets/images';
import { FC } from 'react';
import { useAppSelector } from '../../redux/app/hooks';
import { STUDENT_ROLE, TEACHER_ROLE } from '../../utils/constants';

interface PropsType{
  tabName: "LiveClass" | "Quiz" | "Assignment";
  setShowCreateScheduling?: (val: boolean) => void;
}
const NoLiveSessions:FC<PropsType> = ({setShowCreateScheduling, tabName}) => {
  const {LiveSessionGif, quizIcon} = images;
  const role = useAppSelector((state) => state.auth.role);

  return (
    <div className='noLiveSessionsMainContainer'>
        <div className='NoSessionGifContainer'>
            <img src={tabName === "LiveClass" ? LiveSessionGif : quizIcon} alt='NoSessionGif' className='NoSessionGif'/>
        </div>
        <div className='ctaContainer'>
            <div className='textStyle'>{((tabName === "LiveClass") && (role === TEACHER_ROLE)) ? "No Live Lessons Created Yet!" :  ((tabName === "LiveClass") && (role === STUDENT_ROLE)) ? "No Live Lessons!" :  tabName === "Quiz" ? "No Quiz Created yet!" : "No Assignment Uploaded yet!" }</div>
            {(tabName !== "Assignment") && (role !== STUDENT_ROLE) && <button className='createButtonStyle' onClick={() => {setShowCreateScheduling && setShowCreateScheduling(true)}}>
                Create
            </button>}
        </div>
    </div>
  )
}

export default NoLiveSessions;
